import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CheckSensitiveWord } from '@/infrastructure/api-functions/interface/check-sensitive-word.interface';
import type { AISearchRepository } from '../../service/ai-search.repository.interface';

export const CheckSensitiveWordDTO = Symbol('CheckSensitiveWordDTO');

export interface CheckSensitiveWordDTO {
    fetch: AISearchRepository['checkSensitiveWord'];
}

@injectable()
export class CheckSensitiveWordDTOImpl implements CheckSensitiveWordDTO {
    constructor(
        @inject(CheckSensitiveWord)
        private readonly _checkSensitiveWordApi: CheckSensitiveWord,
    ){}

    async fetch(value: string) {
        try {
            const result = await this._checkSensitiveWordApi.checkSensitiveWord({ tech_desc: value });
            return result?.error_code !== 2;
        } catch (error) {
            return true;
        }
    }
}
